import React from 'react';

import { bemBlock, Emblem, Layout } from '@neptune/shared/venus-ui';

type TagProps = {
  className?: string;
  color?: string;
  tag: string;
  selectable?: boolean;
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onRemove?: (tag: string) => void;
  title?: string;
};

const block = bemBlock('tag');

export const Tag: React.FC<TagProps> = ({
  className,
  color,
  tag,
  selectable = false,
  selected,
  onClick,
  onRemove,
  title,
}) => {
  const handleRemove = onRemove
    ? (event: any) => {
        onRemove(tag);
        event.stopPropagation();
      }
    : undefined;

  return (
    <Layout.Element data-role="tag" data-tag={tag} title={title}>
      <Emblem
        color={color}
        className={block({ extra: className })}
        active={selected}
        onClick={selectable && onClick ? onClick : undefined}
        onEndDetailClick={handleRemove}
        endDetail={handleRemove === undefined ? undefined : 'cancel'}
        text={tag}
      />
    </Layout.Element>
  );
};
